webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(44);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(18);
	
	var _en = __webpack_require__(47);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _App = __webpack_require__(178);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default, {
	  locale: _en2.default
	});
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },

/***/ 15:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var queryString = function (a) {
	  if (a === '') return {};
	  var b = {};
	  for (var i = 0; i < a.length; ++i) {
	    var p = a[i].split('=', 2);
	    if (p.length === 1) {
	      b[p[0]] = '';
	    } else {
	      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' ')) + window.location.hash;
	    }
	  }
	  return b;
	}(window.location.search.substr(1).split('&'));
	
	function detectIE() {
	  var ua = window.navigator.userAgent;
	  var msie = ua.indexOf('MSIE ');
	  if (msie > 0) {
	    return true;
	  }
	
	  var trident = ua.indexOf('Trident/');
	  if (trident > 0) {
	    return false;
	  }
	
	  var edge = ua.indexOf('Edge/');
	  if (edge > 0) {
	    return false;
	  }
	
	  return false;
	}
	
	function isOkPass(p) {
	  var anUpperCase = /[A-Z]/;
	  var aLowerCase = /[a-z]/;
	  var aNumber = /[0-9]/;
	  var obj = {};
	  obj.result = true;
	
	  if (p.length < 8) {
	    obj.result = false;
	    obj.error = 'Must be longer than 8 characters';
	    return obj;
	  }
	
	  var numUpper = 0;
	  var numLower = 0;
	  var numNums = 0;
	
	  for (var i = 0; i < p.length; i++) {
	    if (anUpperCase.test(p[i])) {
	      numUpper++;
	    } else if (aLowerCase.test(p[i])) {
	      numLower++;
	    } else if (aNumber.test(p[i])) {
	      numNums++;
	    }
	  }
	
	  if (numUpper < 1 || numLower < 1 || numNums < 1) {
	    obj.result = false;
	    obj.error = 'Wrong Format!';
	    return obj;
	  }
	  return obj;
	}
	exports.default = {
	  queryString: queryString,
	  isOkPass: isOkPass,
	  detectIE: detectIE
	};

/***/ },

/***/ 18:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 19:
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },

/***/ 123:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(30);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _axios = __webpack_require__(28);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _util = __webpack_require__(15);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      isIe: false,
	      isLocked: false,
	      isResendLocked: true,
	      user: {
	        userid: '',
	        password: '',
	        isMFA: false,
	        userKeyInOTP: ''
	      },
	      rules: {
	        userid: [{
	          required: true,
	          message: 'Please input email address',
	          trigger: 'blur'
	        }, {
	          type: 'email',
	          message: 'Please input correct email address',
	          trigger: 'blur,change'
	        }],
	        password: [{
	          required: true,
	          message: 'Please enter your password',
	          trigger: 'blur'
	        }]
	      },
	      rulesOTP: {
	        userKeyInOTP: [{
	          required: true,
	          message: 'Please enter OTP',
	          trigger: 'blur'
	        }]
	      }
	    };
	  },
	
	  methods: {
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var _ret = function () {
	            var source = _util2.default.queryString.source;
	            if (!source) {
	              source = '/';
	            }
	            _this.user.autoLogin = false;
	            _axios2.default.post('/sign/api/signin?source=' + source, _this.user).then(function (response) {
	              if (response.data[0] === true) {
	                window.location.href = '/sign/auth/cp?info=expired';
	              } else if (response.data[1] === true) {
	                _this.user.isMFA = true;
	              } else {
	                window.location.href = source;
	              }
	            }).catch(function (err) {
	              if (err.response.status > 500) {
	                _this.$message({
	                  type: 'error',
	                  message: 'Error connecting. Please try again...'
	                });
	                return;
	              }
	              if (err.response.data === 'max attempt') {
	                _this.isLocked = true;
	                _this.$message({
	                  type: 'error',
	                  message: 'You’ve reached the maximum logon attempts.'
	                });
	              } else {
	                _this.$message({
	                  type: 'error',
	                  message: err.response.data
	                });
	              }
	            });
	            return {
	              v: true
	            };
	          }();
	
	          if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	        }
	        return false;
	      });
	    },
	    resendOTPForm: function resendOTPForm(formName) {
	      var _this2 = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var source = _util2.default.queryString.source;
	          if (!source) {
	            source = '/';
	          }
	          _this2.user.autoLogin = false;
	          _axios2.default.post('/sign/api/signin/otp', _this2.user).then(function (response) {
	            if (response.data[1] === true) {
	              _this2.user.isMFA = true;
	              _this2.isResendLocked = false;
	            }
	          }).catch(function (err) {
	            if (err.response.status > 500) {
	              _this2.$message({
	                type: 'error',
	                message: 'Error connecting. Please try again...'
	              });
	              return;
	            }
	            if (err.response.data === 'wrong otp') {
	              _this2.$message({
	                type: 'error',
	                message: 'OTP doesnt match.'
	              });
	            } else if (err.response.data === 'otp expired') {
	              _this2.$message({
	                type: 'error',
	                message: 'OTP is expired.'
	              });
	            } else {
	              _this2.$message({
	                type: 'error',
	                message: err.response.data
	              });
	            }
	          });
	          return true;
	        }
	        return false;
	      });
	    },
	    submitOTPForm: function submitOTPForm(formName) {
	      var _this3 = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var _ret2 = function () {
	            var source = _util2.default.queryString.source;
	            if (!source) {
	              source = '/';
	            }
	            _this3.user.autoLogin = false;
	            _axios2.default.post('/sign/api/signin/verify', _this3.user).then(function (response) {
	              if (response.data === true) {
	                window.location.href = source;
	              }
	            }).catch(function (err) {
	              if (err.response.status > 500) {
	                _this3.$message({
	                  type: 'error',
	                  message: 'Error connecting. Please try again...'
	                });
	                return;
	              }
	              if (err.response.data === 'wrong otp') {
	                _this3.$message({
	                  type: 'error',
	                  message: 'OTP doesnt match.'
	                });
	              } else if (err.response.data === 'otp expired') {
	                _this3.$message({
	                  type: 'error',
	                  message: 'OTP is expired.'
	                });
	              } else {
	                _this3.$message({
	                  type: 'error',
	                  message: err.response.data
	                });
	              }
	            });
	            return {
	              v: true
	            };
	          }();
	
	          if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
	        }
	        return false;
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    if (_util2.default.detectIE()) {
	      this.isIe = true;
	    }
	    this.$el.addEventListener('keyup', function (event) {
	      if (event.keyCode === 13) {
	        _this4.submitForm('loginForm');
	      }
	    });
	  },
	  created: function created() {
	    var _this5 = this;
	
	    var username = _util2.default.queryString.u;
	    var userpassword = _util2.default.queryString.p;
	    if (username && userpassword) {
	      (function () {
	        _this5.user.userid = username;
	        _this5.user.password = userpassword;
	        _this5.user.autoLogin = true;
	        var source = _util2.default.queryString.source;
	        if (!source) {
	          source = '/';
	        }
	        _axios2.default.post('/sign/api/signin?source=' + source, _this5.user).then(function (response) {
	          if (response.data[0] === true) {
	            window.location.href = '/sign/auth/cp?info=expired';
	          } else if (response.data[1] === true) {
	            _this5.user.isMFA = true;
	          } else {
	            window.location.href = source;
	          }
	        }).catch(function (err) {
	          if (err.response.status > 500) {
	            _this5.$message({
	              type: 'error',
	              message: 'Error connecting. Please try again...'
	            });
	            return;
	          }
	          if (err.response.data === 'max attempt') {
	            _this5.isLocked = true;
	            _this5.$message({
	              type: 'error',
	              message: 'You’ve reached the maximum logon attempts.'
	            });
	          } else {
	            _this5.$message({
	              type: 'error',
	              message: err.response.data
	            });
	          }
	        });
	      })();
	    }
	  }
	};

/***/ },

/***/ 176:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 178:
/***/ function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(176)
	}
	var Component = __webpack_require__(52)(
	  /* script */
	  __webpack_require__(123),
	  /* template */
	  __webpack_require__(183),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 183:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    staticClass: "bg",
	    attrs: {
	      "type": "flex",
	      "justify": "center",
	      "align": "middle"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 18,
	      "sm": 14,
	      "md": 10,
	      "lg": 6
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": __webpack_require__(19),
	      "alt": "MRC Asia"
	    }
	  }), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.isIe && !_vm.user.isMFA) ? _c('el-form', {
	    ref: "loginForm",
	    attrs: {
	      "label-position": "top",
	      "model": _vm.user,
	      "rules": _vm.rules,
	      "disabled": _vm.isLocked
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "userid"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "email"
	    },
	    model: {
	      value: (_vm.user.userid),
	      callback: function($$v) {
	        _vm.user.userid = $$v
	      },
	      expression: "user.userid"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "password"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "auto-complete": "off"
	    },
	    model: {
	      value: (_vm.user.password),
	      callback: function($$v) {
	        _vm.user.password = $$v
	      },
	      expression: "user.password"
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "/sign/forget"
	    }
	  }, [_vm._v("Forget Password?")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "danger",
	      "plain": "",
	      "disabled": _vm.isLocked
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitForm('loginForm')
	      }
	    }
	  }, [_vm._v("Log in")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isIe && _vm.user.isMFA) ? _c('el-form', {
	    ref: "loginOTPForm",
	    attrs: {
	      "label-position": "top",
	      "model": _vm.user,
	      "disabled": _vm.isLocked
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "One_Time Password",
	      "prop": "userKeyInOTP"
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "240px"
	    },
	    attrs: {
	      "type": "text",
	      "inputmode": "numeric"
	    },
	    model: {
	      value: (_vm.user.userKeyInOTP),
	      callback: function($$v) {
	        _vm.user.userKeyInOTP = $$v
	      },
	      expression: "user.userKeyInOTP"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    staticStyle: {
	      "width": "240px"
	    },
	    attrs: {
	      "type": "danger",
	      "plain": "",
	      "disabled": _vm.isLocked
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitOTPForm('loginOTPForm')
	      }
	    }
	  }, [_vm._v("Verify")]), _vm._v(" "), _c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isResendLocked),
	      expression: "isResendLocked"
	    }],
	    staticStyle: {
	      "width": "140px"
	    },
	    attrs: {
	      "type": "danger",
	      "plain": "",
	      "disabled": _vm.isLocked
	    },
	    on: {
	      "click": function($event) {
	        _vm.resendOTPForm('loginOTPForm')
	      }
	    }
	  }, [_vm._v("Resend OTP")])], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isResendLocked),
	      expression: "!isResendLocked"
	    }],
	    attrs: {
	      "href": "/sign"
	    }
	  }, [_vm._v("Go back to Login")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isIe) ? _c('div', {
	    staticClass: "warning"
	  }, [_c('h2', [_vm._v("Internet Explorer is not supported. Please use a modern browser like Google Chrome, Firefox or Microsoft Edge.")])]) : _vm._e(), _vm._v(" "), (_vm.isLocked) ? _c('div', {
	    staticClass: "warning"
	  }, [_c('h3', [_vm._v("You’ve reached the maximum logon attempts. Your account has been locked. Please contact (65) 6235 2852 for more information.")])]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.739afaf4fe7dcd952d8b.js